import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Link as MuiLink,
  Typography,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  getUserAction,
  resetPasswordAction,
  updateUserAction,
} from "src/app-redux/management/actions/managementActions";
import {
  selectCurrentUser,
  selectRoles,
  selectStatus,
} from "src/app-redux/management/managementSlice";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonButton from "src/components/CommonButton/CommonButton";
import TabHeader from "src/components/TabHeader/TabHeader";
import { ManagementRoute } from "../../../../management.routes";
import { AddUpdateUser, IForm } from "./components/AddUpdateUser";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    pageHeading: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    cardMainParent: {
      float: "left",
      width: "100%",
    },
    cardMain: {
      marginBottom: "30px",
      paddingTop: "10px",
      width: "calc(100%)",
    },
    center: {
      alignItems: "center",
    },
  })
);

interface Props {}

export function UpdateUser({}: Props): React.ReactElement {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const dispatch = useAppDispatch();
  const addStatus = useAppSelector(selectStatus);
  const currentUser: any = useAppSelector(selectCurrentUser);
  const allRoles = useAppSelector(selectRoles);
  const [pageHeading, setPageHeading] = React.useState<any>("Update User");
  const [moduleName, setmoduleName] = React.useState<any>(ManagementRoute.title);
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const [disableUpdate, setDisableUpdate] = useState<boolean>(true);
  const [selectedUserRoles, setSelectedUserRoles] = useState<any>([]);
  const [name, setName] = useState<any>("");
  useEffect(() => {
    dispatch(getUserAction({ userId: id })); // this will call an action that will get from Api and
  }, []);
  const temp: any = [
    {
      roleName: "ADMIN",
      id: 1,
      isActive: true,
    },
    {
      roleName: "GATE-ENTRY OPERATOR",
      id: 2,
      isActive: true,
    },
  ];
  useEffect(() => {
    if (currentUser && currentUser.roles) {
      setName(currentUser.firstName);
    }
    setSelectedUserRoles(temp);
  }, [currentUser]);
  const handleSubmit = async (formData: IForm) => {
    const res = await dispatch(
      updateUserAction({
        ...formData,
        id: Number(id),
      })
    );
    if (res.payload) history.push(ManagementRoute.path);
  };
  // should not be deleted
  const handleResetClick = async () => {
    setOpen(false);
    await dispatch(resetPasswordAction({ userId: Number(id) }));
  };
  const handleCloseAlert = () => {
    setOpen(false);
  };

  const [submitCounter, setSubmitCounter] = useState(0);
  const { height } = UseWindowDimensions();
  let wHeight = 0;
  const minHeight = 132;
  wHeight = height - minHeight;

  const listener = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      !disableUpdate && setSubmitCounter((prev) => prev + 1);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [disableUpdate]);

  return (
    <>
      <TabHeader link={ManagementRoute.path} module={moduleName} heading={pageHeading} />
      <Backdrop className={classes.backdrop} open={addStatus === "loading"}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Grid item xs={12} md={12} className={classes.cardMainParent} style={{ height: wHeight }}>
        {/* <Paper elevation={3} className={classes.cardMain} style={{ height: wHeight }}> */}
        <Box pl={2} pr={2}>
          <Grid container direction="row">
            <Grid item xs={12} md={10}>
              <Typography color="textPrimary" className={classes.pageHeading}>
                {pageHeading}
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <Box textAlign="right">
                <Box component="span">
                  <CommonButton
                    isGreen
                    // disable={disableUpdate}
                    cssClass="customSubmitBtn"
                    onClick={() => setSubmitCounter((prev) => prev + 1)}
                  >
                    Update
                  </CommonButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box m={1}>
          <Divider />
        </Box>
        <Grid container alignItems="center">
          <AddUpdateUser
            allRoles={allRoles}
            submitCounter={submitCounter}
            handleSubmit={handleSubmit}
            initialValues={currentUser}
            selectedUserRoles={selectedUserRoles}
            setDisable={(flag: boolean) => {
              setDisableUpdate(flag); // it get returns a value and update the state and useEffect is Called
            }}
          />
        </Grid>
      </Grid>
      <>
        <Dialog
          open={open}
          onClose={handleCloseAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Typography align="center">
            <DialogTitle id="alert-dialog-title" className={classes.center}>
              {"Reset Password"}
            </DialogTitle>
          </Typography>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to reset password?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAlert} variant="contained">
              Cancel
            </Button>
            <Button onClick={handleResetClick} variant="contained" color="secondary">
              Reset Password
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </>
  );
}
